/**
 * Editorial fallbacks for the public site.
 *
 * Featured + catalog pets are now driven by the live API (see usePublicPets);
 * this file only keeps:
 *   • HERO_COVER  — the cover polaroid (intentionally not API-picked).
 *   • TICKER_NAMES — fallback names for the marquee strip when the API is
 *                    unreachable, so the design never reads as a build error.
 */

import type { HeroCoverPet } from '../components/sections/Hero';

const TOK = {
  ink: '#0f2a4a',
  paper: '#f3ead8',
  ochre: '#c68c3b',
} as const;

export const HERO_COVER: HeroCoverPet = {
  name: 'Biscoito',
  caption: 'Biscoito · ch. 03',
  stamp: 'espera\nhá 4 meses',
  illustration: {
    kind: 'dog',
    variant: 'default',
    palette: { bg: TOK.ochre, body: TOK.ink, eyes: TOK.paper, mouth: TOK.paper },
  },
};

export const TICKER_NAMES: string[] = [
  'Biscoito', 'Mel', 'Tareco', 'Cacau',
  'Nina', 'Pipoca', 'Rocha', 'Luna',
];
